<ng-content></ng-content>

<p class="text-muted text-center" *ngIf="infoText">{{infoText | translate}}</p>
